 
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import { PageTitleAndSubTitle } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import Loader from '../../_components/molecules/Loader';
import risingRiskPageMessages from '../../core-utils/messages/risingRiskPageMessages';
import { MonthMap } from '../../core-utils/helper-utils/EditDuration';
import moment from 'moment';
import {
  DATE_FORMAT,
  MONTH_YEAR_FORMAT,
} from '../../core-utils/messages/CommonConstants';
import { useStores } from '../../stores';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RisingRiskOverviewTab from '../../_components/molecules/RisingRiskOverviewTab';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';

export interface MembersOfSelectedDiseaseDataProps {
  member_unique_id: string;
  risk_score: string;
  relevant_conditions: string;
}

export interface RisingRiskPageProps {}

const RisingRiskPage: React.FC<RisingRiskPageProps> = ({}) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
    },
    membersHeadingGrid: {
      margin: '10px 0px 30px 0px',
    },
    membersTableHeader: {
      height: '48px',
      backgroundColor: '#F2F4FA',
    },
    mainGrid: {
      marginLeft: '63px',
    },
    topGrid: {
      marginTop: '38px',
    },
    belowCards: {
      marginRight: '24px',
      marginBottom: '24px',
    },
    belowSummaryCards: {
      display: 'flex',
      marginTop: '20px',
    },
    valueSliderComponentValueStyles: {
      marginTop: '26px',
    },
  });

  const { classes } = useStyles();

  const messages = risingRiskPageMessages.RISING_RISK_PAGE;
  const [loading, setLoading] = useState<boolean>(false);

  const riskProbability = 0.7;

  const employerGroupStore = useStores().employerGroupStore;
  const risingRiskStore = useStores().risingRiskStore;
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [areDatesReady, setAreDatesReady] = useState<boolean>(false);
  // need this when dates are displayed.
  const [startMonthYearString, setStartMonthYearString] = useState<string>('');
  const [endMonthYearString, setEndMonthYearString] = useState<string>('');
  const [planStartMonth, setPlanStartMonth] = useState<string>('');
  const [yearArray, setYearArray] = useState<string[]>([]);
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const getDates = async () => {
    setLoading(true);
    const dateFilterResponse = employerGroupStore.employerGroupResponseData;
    const monthNumber = MonthMap.get(dateFilterResponse.end_month)?.monthNumber;
    const defaultDate = new Date(
      monthNumber + '-01-' + dateFilterResponse.end_year,
    );

    setStartDate(
      moment(defaultDate).subtract(11, 'months').format(DATE_FORMAT),
    );

    setStartMonthYearString(
      moment(defaultDate).subtract(11, 'months').format(MONTH_YEAR_FORMAT),
    );

    setEndDate(moment(defaultDate).endOf('month').format(DATE_FORMAT));

    setEndMonthYearString(
      moment(defaultDate).endOf('month').format(MONTH_YEAR_FORMAT),
    );

    setPlanStartMonth(dateFilterResponse?.plan_start_month);

    let startYearNumber = Number(dateFilterResponse?.start_year);
    const endYearNumber = Number(
      moment(defaultDate).subtract(11, 'months').format('YYYY'),
    );

    while (startYearNumber <= endYearNumber) {
      yearArray.push(startYearNumber.toString());
      startYearNumber++;
    }
    setYearArray([...yearArray]);

    setAreDatesReady((prev: any) => !prev);

    setLoading(false);
  };

  const recommendedTabStore = useStores().recommendedTabStore;

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  useEffect(() => {
    getDates();
    risingRiskStore.removeMembersUniqueList();
    risingRiskStore.removeSelectedDiseaseName();
  }, []);

  const [loader] = useState<any>(<Loader />);

  return (
    <>
      {loading ? (
        loader
      ) : (
        <Grid container className={classes.root}>
          <Grid
            style={{
              marginBottom: '36px',
              width: '1182px',
              position: 'relative',
            }}
          >
            <PageTitleAndSubTitle
              title={messages.TITLE}
              subTitle={messages.SUBTITLE.PART1}
              showDownloadButton={true}
              downloadButtonAction={() => setOpenReportsModal(true)}
            />
            {/* Need this code in the upcoming releases.
              <div
                style={{
                  position: 'absolute',
                  top: '-3px',
                  left: '100px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  for
                </Typography>
                <EditDuration
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  getAllApis={getAllCharts}
                  isYearGrid={true}
                  startDate={moment(startDate, DATE_FORMAT)}
                  endDate={moment(endDate, DATE_FORMAT)}
                  startMonthYearString={startMonthYearString}
                  setStartMonthYearString={setStartMonthYearString}
                  endMonthYearString={endMonthYearString}
                  setEndMonthYearString={setEndMonthYearString}
                  planStartMonth={planStartMonth}
                  startYearArray={yearArray}
                />
              </div> */}
            <TabSelection
              selectedTabIndex={selectedTabIndex}
              setSelectedTabIndex={handleSelectedIndex}
              recommendationFetched={recommendationFetched}
            />
          </Grid>
          <Grid>
            {selectedTabIndex === 0 && (
              <RisingRiskOverviewTab startDate={startDate} endDate={endDate} />
            )}
            {selectedTabIndex === 1 && (
              <RecommendationsTab
                recommendationLoading={recommendationLoading}
                isInternalPage={true}
              />
            )}
          </Grid>
        </Grid>
      )}
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={startDate}
        endDate={endDate}
        riskProbability={riskProbability}
      />
    </>
  );
};

export default RisingRiskPage;
